import { Colors } from '@brg/ui';
export var greyTheme = {
    accent: {
        colorA: '',
        colorB: '',
        colorC: '',
        colorD: ''
    },
    app: {
        backgroundColor: Colors.geo,
        text: Colors.geoWhite100,
        ten: Colors.galBlack73
    },
    reportFormWhite: {
        backgroundColor: '#fefefe',
        text: '#151514',
        scroll: '#909090',
        btns: {
            submit: {
                bg: '#151514',
                disabledBg: '#B6B6B5',
                disabledColor: '#FEFEFE',
                color: '#FEFEFE',
                border: '',
                hoverBg: '#efd649',
                weight: '',
            },
            cancel: {
                bg: '',
                color: '#151514',
                border: '1px solid #151514',
                hoverBorder: '1px solid #b1b1b1',
            }
        },
        inputs: {
            dropdown: {
                backgroundColor: Colors.galBlack5,
                backgroundColorHover: Colors.galBlack10,
                scroll: Colors.galBlack47,
            },
            optionsBox: {
                shadowColor: 'linear-gradient(180deg, rgba(50, 55, 59, 0.09) 0%, #32373b 100%)',
                borderColor: Colors.galBlack100,
            },
            backgroundColor: Colors.galBlack5,
            borderColor: Colors.galBlack5,
            color: '#151514',
        }
    },
    mainBg: '#2A3034',
    tagView: {
        titleColor: Colors.geoWhite100,
        // Медиа
        goToMediaColor: Colors.geoWhite100,
        goToMediaHoverColor: Colors.geoWhite31
    },
    longread: {
        border: 'none',
        fontSize: '',
        lineHeight: ''
    },
    progressbar: {
        color: Colors.geoWhite47,
        colorBold: Colors.geoWhite100,
        borderColor: Colors.geoWhite31
    },
    competition: {
        search: {
            smallColor: Colors.galBlack61
        }
    },
    cardsEmptyModal: {
        titleColor: '#000',
        subtitleColor: Colors.galBlack100,
        bg: '#FEFEFE',
        buttons: {
            filled: {
                color: '#FFF',
                bg: Colors.galBlack100
            },
            hollow: {
                color: Colors.galBlack100,
                border: Colors.galBlack47
            }
        }
    },
    tagSearch: {
        titleColor: Colors.geoWhite47,
        subtitleColor: Colors.geoWhite47,
        subtitleColorHover: Colors.geoWhite100,
        inputColor: Colors.geoWhite100,
        background: Colors.geoWhite5,
        arrowColor: Colors.geoWhite47
    },
    catalog: {
        titleColor: Colors.geoWhite100
    },
    tagItemView: {
        textColor: Colors.geoWhite100,
        borderColor: Colors.geoWhite47,
        borderColorHover: Colors.geoWhite100
    },
    filterBar: {
        textColor: '#8e9193',
        textColorHover: Colors.geoWhite100
    },
    exploreView: {
        titleColor: Colors.geoWhite100,
        mapGridToggle: {
            color: Colors.geoWhite47,
            colorHover: Colors.geoWhite100
        },
        illustrationColor: Colors.geoWhite73
    },
    allTagsBtn: {
        color: Colors.geoWhite47,
        colorHover: Colors.geoWhite100,
        colorBooksBtn: '#909090',
        colorHoverBooksBtn: '#545453'
    },
    multipleAuthors: {
        color: '#8e9193',
        colorHover: '#151514',
        bg: Colors.galBlack5,
        bgHover: '#F2F2F2',
        arrow: '#151514',
        border: '1px solid #151514',
        shadow: '0px 4px 4px rgba(0, 0, 0, 0.12)'
    },
    designerRole: Colors.geoWhite61,
    designerRoleUniversity: Colors.geoWhite100,
    textBoldMagic: Colors.geoWhite47,
    teamLink: Colors.geoWhite100,
    teamLinkHover: Colors.geoWhite61,
    teamLinkHoverAccent: Colors.geoWhite61,
    projectToolsDropdown: {
        border: '',
        borderColor: 'transparent'
    },
    paginationBtn: {
        color: '',
        border: ''
    },
    sortByColor: Colors.geoWhite47,
    sortByColorSort: Colors.geoWhite100,
    sortByBorder: '',
    sortByBg: '',
    sortBySpan: '#fefefe',
    nameViewHover: '#fefefe',
    nameView: '#8e9193',
    reportForm: {
        backgroundColor: '#262a2d',
        text: '#fefefe',
        btns: {
            submit: {
                bg: '#fede31',
                color: '#262a2d',
                border: '',
                hoverBg: '#efd649',
                weight: ''
            },
            cancel: {
                bg: '',
                color: '',
                border: '',
                hoverBorder: ''
            }
        },
        inputs: {
            optionsBox: {
                shadowColor: 'linear-gradient(180deg, rgba(50, 55, 59, 0.09) 0%, #32373b 100%)',
                borderColor: 'transparent'
            },
            dropdown: {
                backgroundColorHover: ''
            },
            backgroundColor: '#30363a',
            borderColor: '#30363a',
            color: '#fefefe'
        }
    },
    feedbackForm: {
        backgroundColor: '#262a2d',
        text: '#fefefe',
        btns: {
            submit: {
                bg: '#fede31',
                color: '#262a2d',
                border: '',
                hoverBg: '#efd649',
                weight: ''
            },
            cancel: {
                bg: '',
                color: '',
                border: '',
                hoverBorder: ''
            }
        },
        inputs: {
            optionsBox: {
                shadowColor: 'linear-gradient(180deg, rgba(50, 55, 59, 0.09) 0%, #32373b 100%)',
                borderColor: 'transparent'
            },
            dropdown: {
                backgroundColorHover: ''
            },
            backgroundColor: '#30363a',
            borderColor: '#30363a',
            color: '#fefefe'
        }
    },
    projectView: {
        titleColor: Colors.geoWhite100,
        titleColorMobile: Colors.geoWhite100,
        placeholderColor: Colors.zelWhite31,
        fontSize: '',
        lineHeight: '',
        categoryText: Colors.geoWhite31,
        categoryWeight: '',
        categoryColorHover: '',
        authorText: 'rgba(255,255,255,0.47)',
        authorCuratorText: Colors.geoWhite100,
        authorTextMobile: Colors.geoWhite100,
        authorWeight: '400',
        authorTextSize: Colors.geoWhite73,
        authorColor: Colors.geoWhite47,
        authorColorHover: Colors.geoWhite100,
        authorColorHoverMobile: Colors.geoWhite61,
        authorArrowIconColor: Colors.geoWhite47,
        textAreaColor: Colors.geoWhite31,
        viewCardText: '#FEFEFE',
        viewCardStroke: '#909090',
        marginTop: '',
        marginBottom: '',
        designerLink: Colors.geoWhite100,
        moreProjects: '#FFFFFF',
        offsetTop: '',
        madeBy: Colors.geoWhite47,
        border: 'transparent',
        competitionMsg: Colors.geoWhite100
    },
    backgroundModal: {
        gradient: 'linear-gradient(180deg, rgba(38, 44, 48, 0.52) 0%, rgba(38, 44, 48, 0.9) 100%)'
    },
    footerView: {
        backgroundColor: '#22282c',
        textColor: Colors.geoWhite61,
        textHoverColor: Colors.generalPeaGreen,
        link: Colors.geoWhite47,
        linkHover: Colors.geoWhite100,
        linkArrow: Colors.geoWhite27
    },
    arrowWithText: {
        hover: {
            text: {
                color: 'rgb(254,254,254)'
            },
            svg: {
                fill: 'rgb(254,254,254)',
                stroke: 'rgb(254,254,254)'
            }
        },
        longreadSort: {
            text: {
                color: '#151514'
            },
            svg: {
                fill: '#151514',
                stroke: Colors.galBlack100
            }
        }
    },
    teamsPage: {
        dropdown: {
            text: {
                color: '#f4f4f4'
            }
        },
        text: {
            point: {
                color: '#f4f4f4'
            },
            label: {
                color: '#8E9193'
            },
            color: '#ffffff'
        }
    },
    fixedFooter: {
        background: {
            color: '#353A3E'
        },
        logo: {
            color: '#FEFEFE'
        },
        menuItems: {
            color: '#8E9193',
            colorHover: 'rgb(254, 254, 254)'
        },
        doc: {
            color: '#909090',
            colorHover: '#151514'
        },
        icons: {
            circle: '#353A3E'
        },
        dropdown: {
            color: '#8E9193',
            fill: '#8E9193'
        }
    },
    legals: {
        textColor: Colors.geoWhite100,
        background: "".concat(Colors.geo, "FA"),
        closeBtn: Colors.geoWhite47,
        link: Colors.geoWhite47,
        linkHover: Colors.geoWhite100
    },
    projectEdit: {
        imgContainerBg: '#353A3E',
        svgImgFill: Colors.zelWhite47,
        textTips: Colors.zelWhite47,
        locationText: Colors.geoWhite61,
        locationBoldText: Colors.geoWhite47,
        label: Colors.zelWhite47,
        radio: {
            dot: {
                color: '#151514'
            }
        },
        btns: {
            create: {
                bg: '',
                color: '',
                weight: '',
                border: ''
            }
        }
    },
    icon: {
        default: 'rgba(255,255,255,0.47)',
        hover: Colors.geoWhite100,
        active: Colors.geoWhite100,
        hoverSpecial: Colors.geoWhite100,
        hoverSpecialActive: Colors.geoWhite73,
        activeSpecial: Colors.geoWhite100,
        activeFillIconColor: Colors.geoWhite100,
        chat: {
            activeSpecial: '#151514',
            default: '#909090',
            activeFillIconColor: '#151514',
            hoverSpecialActive: '#151514'
        }
    },
    tags: {
        extraBackgroundColor: 'transparent',
        textColor: Colors.geoWhite100,
        tagsBgDisabled: '#272b2d ',
        tagsColorDisabled: Colors.geoWhite21,
        tagsBorderDisabled: '#3f4548',
        projectEditTagsPlusBtn: '#fefefe',
        tagsSearchPlaceholderText: Colors.geoWhite61,
        emptySearchColor: Colors.geoWhite61,
        borderColor: Colors.geoWhite47,
        borderColorHover: Colors.geoWhite100,
        borderColorActive: Colors.geoWhite100,
        removable: {
            textColorHover: Colors.geoWhite47,
            borderColorHover: Colors.geoWhite47,
            // Selected when removable
            selected: {
                line: {
                    color: Colors.galBlack100
                },
                textColor: Colors.galBlack47,
                borderColor: '#a4b54d'
            }
        },
        selected: {
            backgroundColor: '#a4b54d',
            borderColor: '#a4b54d',
            textColor: '#2a3034',
            hover: {
                borderColor: '#a4b54d'
            }
        },
        disabled: {
            backgroundColor: '#272b2d',
            borderColor: '#3f4548',
            color: Colors.geoWhite21,
            hover: {
                borderColor: '#3f4548'
            }
        },
        educational: {
            backgroundColor: Colors.geoWhite100,
            color: Colors.galBlack100,
            backgroundColorHover: Colors.galBlack31,
            projectEdit: {
                backgroundColor: Colors.galBlack100,
                color: '#fefefe',
            }
        },
        modal: {
            search: {
                color: Colors.geoWhite47,
                border: Colors.geoWhite21
            },
            text: {
                color: Colors.geoWhite47
            },
            active: {
                activeTag: Colors.geoWhite100,
                border: Colors.geoWhite61
            },
            notActive: {
                tag: Colors.geoWhite73,
                border: Colors.geoWhite31
            },
            simpleTag: {
                color: Colors.geoWhite100
            }
        }
    },
    skeleton: {
        skeletonBgColor: '',
        background: "linear-gradient(\n            90deg,\n            rgba(255, 255, 255, 0.02),\n            rgba(255, 255, 255, 0.02),\n            rgba(255, 255, 255, 0.02),\n            rgba(255, 255, 255, 0.07),\n            rgba(255, 255, 255, 0.02),\n            rgba(255, 255, 255, 0.02),\n            rgba(255, 255, 255, 0.02)\n        )"
    },
    selectContextModal: {
        background: Colors.geo,
        opacityTop: 'linear-gradient(to top, rgba(42, 48, 52, 0), rgba(42, 48, 52, 0.6) 12.39%, rgba(42, 47, 52, 1))',
        opacityBottom: 'linear-gradient(to bottom, rgba(42, 48, 52, 0), rgba(42, 48, 52, 0.6) 12.39%, rgba(42, 47, 52, 1))',
        variantTextColor: Colors.geoWhite100
    },
    shopIcon: Colors.geoWhite100,
    shareIcon: Colors.geoWhite100,
    navigationBar: {
        borderBottomColor: Colors.geoWhite21,
        textActiveColor: '#ffffff',
        boxShadow: 'inset 0px 2px 3px rgba(22, 22, 23, 0.21)',
        closeButtonColor: '#FFFFFF',
        backgroundColor: Colors.geo,
        backgroundScrollingColor: 'rgba(42, 48, 52, 0.71)',
        chat: {
            btns: {
                hollow: {
                    text: {
                        main: '#151514'
                    },
                    bg: {
                        main: 'transparent',
                        hover: 'transparent'
                    },
                    border: {
                        main: 'rgb(182, 182, 181)',
                        hover: 'rgb(182, 182, 181)'
                    }
                },
                filled: {
                    text: {
                        main: '#fefefe'
                    },
                    bg: {
                        main: '#151514',
                        hover: '#151514'
                    },
                    border: {
                        main: 'transparent',
                        hover: 'transparent'
                    }
                }
            }
        },
        font: {
            l: {
                fontSize: '17px',
                lineHeight: '22px'
            },
            m: {
                fontSize: '15px',
                lineHeight: '20px'
            },
            s: {
                fontSize: '13px',
                lineHeight: '16px'
            }
        },
        links: {
            color: Colors.geoWhite73,
            hoverColor: Colors.geoWhite100,
            activeColor: Colors.geoWhite100
        },
        linksHse: {
            color: Colors.geoWhite47,
            hoverColor: Colors.geoWhite100,
            activeColor: Colors.geoWhite100
        },
        logoName: Colors.geoWhite100,
        login: {
            loginButtonColor: Colors.geoWhite47,
            loginButtonHoverColor: Colors.geoWhite100,
            noAvatarBackgroundColor: '#30363A',
            noAvatarTextColor: '#707477'
        },
        search: {
            color: '#FEFEFE',
            line: '#FFFFFF',
            svg: '#FEFEFE',
            svgHover: Colors.geoWhite100,
            colorFlex: 'rgb(254, 254, 254, 0.71)'
        },
        modalMobileLinks: {
            default: Colors.galBlack47,
            active: '#C7D332'
        },
        linksWidgetLine: '#ffffff',
        linksWidgetLineGradient: Colors.geoWhite100,
        btns: {
            filled: {
                importantStyles: {
                    main: Colors.geoWhite100,
                    disabled: Colors.galBlack10,
                    hover: Colors.geoWhite100,
                    active: Colors.galBlack10,
                    text: Colors.galBlack100
                },
                background: {
                    main: Colors.generalPeaGreen,
                    disabled: Colors.galBlack10,
                    hover: 'rgba(164, 181, 77, 0.8)',
                    active: 'rgba(164, 181, 77, 0.8)'
                },
                text: {
                    main: Colors.galBlack100,
                    disabled: Colors.geoWhite73
                }
            },
            hollow: {
                background: {
                    disabled: Colors.geoWhite73
                },
                text: {
                    main: '#ffffff',
                    grey: Colors.geoWhite31,
                    black: Colors.galBlack100,
                    disabled: Colors.geoWhite47
                },
                border: {
                    main: Colors.geoWhite21,
                    hover: Colors.geoWhite31,
                    active: Colors.geoWhite47,
                    disabled: Colors.geoWhite10
                }
            },
            send: {
                color: '',
                textColor: '',
                border: ''
            },
            create: {
                bg: 'rgb(164, 181, 77)',
                color: Colors.galBlack100,
                weight: '',
                border: ''
            },
            changeLang: {
                background: Colors.geoWhite5,
                color: Colors.geoWhite47,
                colorMobile: Colors.geoWhite100,
                colorHover: Colors.geoWhite47,
                active: Colors.geoWhite100
            }
        },
        navBarCreate: {
            boldTextColor: Colors.geoWhite61,
            textColor: '#6C7073',
            logoFillColor: {
                first: '#FEFEFE',
                second: '#A4B54D'
            }
        },
        dropdownStyled: {
            bg: '#30363a',
            border: '1px solid rgba(254, 254, 254, 0)',
            borderFocused: 'rgba(254, 254, 254, 0.13)',
            textColor: '#fefefe',
            opacity: '0.31',
            fill: '#fefefe'
        },
        profile: {
            textColor: Colors.geoWhite100,
            textSmallColor: Colors.geoWhite61,
            bg: Colors.geo
        }
    },
    mobileSearch: {
        wrapper: {
            background: Colors.geoWhite5
        },
        input: {
            color: Colors.geoWhite100
        },
        item: {
            color: Colors.geoWhite100
        }
    },
    likesController: {
        textColor: Colors.geoWhite47,
        fill: '',
        hearthColor: Colors.geoWhite47,
        hearthColorLikes: Colors.redFailed,
        text: Colors.geoWhite47
    },
    viewCount: {
        text: Colors.geoWhite47
    },
    likesPopUp: {
        bg: '#1c1c1b',
        color: '#abaeaf',
        hoverColor: Colors.geoWhite100,
        bgHover: '',
        borderBox: '1px solid transparent'
    },
    researchPage: {
        colorMainTitle: Colors.geoWhite61
    },
    btns: {
        submit: {
            bg: '#fede31',
            color: Colors.galBlack100,
            border: '',
            hoverBg: '#efd649',
            weight: ''
        },
        cancel: {
            bg: '',
            color: '',
            border: '',
            hoverBorder: ''
        },
        hollow: {
            border: Colors.geoWhite21,
            borderActive: Colors.geoWhite100,
            icon: Colors.geoWhite100
        }
    },
    inputs: {
        optionsBox: {
            shadowColor: 'linear-gradient(180deg, rgba(50, 55, 59, 0.09) 0%, #32373b 100%)',
            borderColor: 'transparent'
        },
        dropdown: {
            backgroundColorHover: ''
        },
        backgroundColor: '#30363a',
        borderColor: '#30363a',
        borderFocusedColor: Colors.geoWhite31,
        color: '#f4f4f4',
        disabledColor: Colors.geoWhite100,
        pagination: {
            backgroundColor: Colors.galBlack10,
            color: Colors.galBlack100
        },
        box: {
            backgroundColor: Colors.geoWhite5
        },
        label: {
            color: '#f4f4f4'
        },
        text: {
            color: Colors.geoWhite47
        }
    },
    dropdown: {
        textColor: Colors.galBlack100,
        bgColor: '#32373b',
        bgColorHover: 'rgba(31, 31, 31, 0.31)',
        borderColor: '#30363a',
        borderFocusColor: 'transparent',
        arrow: '#fefefe'
    },
    spinner: {
        loaderColor: '#ffffff',
        loaderBg: Colors.geo
    },
    designerPage: {
        emptyProjectsLoader: {
            color: Colors.geoWhite100,
            bg: '#30363a'
        },
        likePowerIcon: {
            color: Colors.geoWhite47,
            bg: 'rgba(254,254,254,0.73)',
            opacity: '0.73',
            msgColor: Colors.galBlack100,
            shrinkColor: Colors.galBlack100,
            hover: Colors.geoWhite73
        },
        textColor: Colors.geoWhite100,
        textColor2: Colors.geoWhite47,
        textColor3: Colors.geoWhite100,
        fill: '#FEFEFE',
        moreDropdown: '',
        slideLine: '#f4f4f4',
        slideLineInActive: Colors.galBlack47,
        slideHover: Colors.geoWhite73,
        viewCardText: '#FEFEFE',
        viewCardStroke: '#8e9193'
    },
    teamsEdit: {
        inputs: {
            labelColor: '#575B5E',
            importantColor: Colors.geoWhite47,
            whiteLabelColor: Colors.galBlack47,
            bgDisabled: '',
            border: '',
            bg: '',
            color: '#f4f4f4',
            colorShadow: 'rgb(142, 145, 147)'
        }
    },
    designerEdit: {
        btns: {
            edit: {
                bg: 'rgb(164, 181, 77)',
                color: Colors.galBlack100,
                border: '',
                hoverBg: '#efd649',
                weight: ''
            },
            cancel: {
                bg: '',
                color: '#f4f4f4',
                border: '',
                hoverBorder: ''
            },
            roundAdd: {
                svgColor: Colors.geoWhite100,
                textColor: Colors.geoWhite47
            }
        },
        localSwitch: {
            borderColor: Colors.geoWhite100,
            textColor: Colors.geoWhite100,
            textColorInactive: Colors.geoWhite47,
            textColorHover: Colors.geoWhite73
        },
        inputs: {
            labelColor: '#575B5E',
            importantColor: Colors.geoWhite47,
            whiteLabelColor: Colors.galBlack47,
            bgDisabled: '',
            border: '',
            bg: '',
            color: '#f4f4f4',
            colorShadow: 'rgb(142, 145, 147)'
        },
        smallText: {
            color73: Colors.geoWhite73,
            color100: '#f4f4f4',
            color47: Colors.geoWhite47,
            colorE7: '#e7e7e7'
        },
        editTitle: {
            color: '#f4f4f4'
        },
        mainTitle: {
            color: '#f4f4f4'
        },
        pageLink: {
            color: Colors.geoWhite100,
            hoverColor: Colors.geoWhite100
        },
        aboutProfile: {
            bg: '#353a3e',
            bgWhite: Colors.geoWhite73,
            color: Colors.geoWhite100
        },
        account: {
            color: '#f4f4f4',
            color47: Colors.geoWhite47,
            goButtonColor: 'rgb(244,244,244)',
            color31: Colors.geoWhite31,
            fill: 'rgb(205, 205, 205)'
        },
        icons: {
            color: Colors.geoWhite47,
            colorHover: Colors.geoWhite100
        },
        disable: {
            color: Colors.geoWhite27,
            colorGeo: Colors.galBlack47
        },
        placeholder: {
            color: 'rgb(108, 112, 115)'
        }
    },
    map: {
        closeBtn: '#ffffff',
        bg: '#2a3034'
    },
    footer: {
        border: ''
    },
    errorModal: {
        textColor: Colors.geoWhite100,
        secondaryTextColor: Colors.geoWhite47,
        backgroundColor: Colors.geo
    },
    modal: {
        closeColor: Colors.geoWhite100,
        backgroundColor: 'linear-gradient(180deg, rgba(38, 44, 48, 0.52) 0%, rgba(38, 44, 48, 0.9) 100%)',
        solidBackgroundColor: Colors.geo
    },
    not_saved_modal: {
        title: '#f4f4f4',
        description: 'rgb(197, 198, 199)',
        cancel: Colors.galBlack100,
        proceed: Colors.geoWhite100
    },
    gallllery: {
        cardSubtext: '#919191',
        mainText: Colors.galBlack100,
        mainTextInactive: '#969696',
        hoverTitleText: '#FFD700',
        hoverText: '#919191',
        hoverAuthor: Colors.galBlack100,
        backgroundColor: 'white',
        borderBottomColor: 'transparent',
        boxShadow: 'none',
        backdrop: 'blur(1px)'
    },
    artz: {
        searchLine: {
            placeholderColor: '#1F1F1F',
            textColor: Colors.galBlack100
        },
        buttons: {
            viewAllColor: Colors.gal
        }
    },
    menuOverlay: {
        buttonBackground: '#353a3e',
        buttonContent: '#C5C6C7',
        buttonOpacity: 0.39,
        backgroundColor: '#2a3034',
        textColor: '#ffffff',
        textColorAlternative: '#ABAEAF',
        borderTitle: '#fefefe',
        flexBox: 'rgb(254, 254, 254, 0.71)'
    },
    approvals: {},
    isDarkText: false,
    link: {
        default: Colors.geoWhite47,
        hover: Colors.geoWhite100
    },
    scrollUp: {
        link: Colors.zelWhite100,
        background: 'transparent'
    },
    text: {
        label: Colors.geoWhite47
    }
};
//# sourceMappingURL=greyTheme.js.mapimport { Colors } from '@brg/ui';
export var greyTheme = {
    accent: {
        colorA: '',
        colorB: '',
        colorC: '',
        colorD: ''
    },
    app: {
        backgroundColor: Colors.geo,
        text: Colors.geoWhite100,
        ten: Colors.galBlack73
    },
    reportFormWhite: {
        backgroundColor: '#fefefe',
        text: '#151514',
        scroll: '#909090',
        btns: {
            submit: {
                bg: '#151514',
                disabledBg: '#B6B6B5',
                disabledColor: '#FEFEFE',
                color: '#FEFEFE',
                border: '',
                hoverBg: '#efd649',
                weight: '',
            },
            cancel: {
                bg: '',
                color: '#151514',
                border: '1px solid #151514',
                hoverBorder: '1px solid #b1b1b1',
            }
        },
        inputs: {
            dropdown: {
                backgroundColor: Colors.galBlack5,
                backgroundColorHover: Colors.galBlack10,
                scroll: Colors.galBlack47,
            },
            optionsBox: {
                shadowColor: 'linear-gradient(180deg, rgba(50, 55, 59, 0.09) 0%, #32373b 100%)',
                borderColor: Colors.galBlack100,
            },
            backgroundColor: Colors.galBlack5,
            borderColor: Colors.galBlack5,
            color: '#151514',
        }
    },
    mainBg: '#2A3034',
    tagView: {
        titleColor: Colors.geoWhite100,
        // Медиа
        goToMediaColor: Colors.geoWhite100,
        goToMediaHoverColor: Colors.geoWhite31
    },
    longread: {
        border: 'none',
        fontSize: '',
        lineHeight: ''
    },
    progressbar: {
        color: Colors.geoWhite47,
        colorBold: Colors.geoWhite100,
        borderColor: Colors.geoWhite31
    },
    competition: {
        search: {
            smallColor: Colors.galBlack61
        }
    },
    cardsEmptyModal: {
        titleColor: '#000',
        subtitleColor: Colors.galBlack100,
        bg: '#FEFEFE',
        buttons: {
            filled: {
                color: '#FFF',
                bg: Colors.galBlack100
            },
            hollow: {
                color: Colors.galBlack100,
                border: Colors.galBlack47
            }
        }
    },
    tagSearch: {
        titleColor: Colors.geoWhite47,
        subtitleColor: Colors.geoWhite47,
        subtitleColorHover: Colors.geoWhite100,
        inputColor: Colors.geoWhite100,
        background: Colors.geoWhite5,
        arrowColor: Colors.geoWhite47
    },
    catalog: {
        titleColor: Colors.geoWhite100
    },
    tagItemView: {
        textColor: Colors.geoWhite100,
        borderColor: Colors.geoWhite47,
        borderColorHover: Colors.geoWhite100
    },
    filterBar: {
        textColor: '#8e9193',
        textColorHover: Colors.geoWhite100
    },
    exploreView: {
        titleColor: Colors.geoWhite100,
        mapGridToggle: {
            color: Colors.geoWhite47,
            colorHover: Colors.geoWhite100
        },
        illustrationColor: Colors.geoWhite73
    },
    allTagsBtn: {
        color: Colors.geoWhite47,
        colorHover: Colors.geoWhite100,
        colorBooksBtn: '#909090',
        colorHoverBooksBtn: '#545453'
    },
    multipleAuthors: {
        color: '#8e9193',
        colorHover: '#151514',
        bg: Colors.galBlack5,
        bgHover: '#F2F2F2',
        arrow: '#151514',
        border: '1px solid #151514',
        shadow: '0px 4px 4px rgba(0, 0, 0, 0.12)'
    },
    designerRole: Colors.geoWhite61,
    designerRoleUniversity: Colors.geoWhite100,
    textBoldMagic: Colors.geoWhite47,
    teamLink: Colors.geoWhite100,
    teamLinkHover: Colors.geoWhite61,
    teamLinkHoverAccent: Colors.geoWhite61,
    projectToolsDropdown: {
        border: '',
        borderColor: 'transparent'
    },
    paginationBtn: {
        color: '',
        border: ''
    },
    sortByColor: Colors.geoWhite47,
    sortByColorSort: Colors.geoWhite100,
    sortByBorder: '',
    sortByBg: '',
    sortBySpan: '#fefefe',
    nameViewHover: '#fefefe',
    nameView: '#8e9193',
    reportForm: {
        backgroundColor: '#262a2d',
        text: '#fefefe',
        btns: {
            submit: {
                bg: '#fede31',
                color: '#262a2d',
                border: '',
                hoverBg: '#efd649',
                weight: ''
            },
            cancel: {
                bg: '',
                color: '',
                border: '',
                hoverBorder: ''
            }
        },
        inputs: {
            optionsBox: {
                shadowColor: 'linear-gradient(180deg, rgba(50, 55, 59, 0.09) 0%, #32373b 100%)',
                borderColor: 'transparent'
            },
            dropdown: {
                backgroundColorHover: ''
            },
            backgroundColor: '#30363a',
            borderColor: '#30363a',
            color: '#fefefe'
        }
    },
    feedbackForm: {
        backgroundColor: '#262a2d',
        text: '#fefefe',
        btns: {
            submit: {
                bg: '#fede31',
                color: '#262a2d',
                border: '',
                hoverBg: '#efd649',
                weight: ''
            },
            cancel: {
                bg: '',
                color: '',
                border: '',
                hoverBorder: ''
            }
        },
        inputs: {
            optionsBox: {
                shadowColor: 'linear-gradient(180deg, rgba(50, 55, 59, 0.09) 0%, #32373b 100%)',
                borderColor: 'transparent'
            },
            dropdown: {
                backgroundColorHover: ''
            },
            backgroundColor: '#30363a',
            borderColor: '#30363a',
            color: '#fefefe'
        }
    },
    projectView: {
        titleColor: Colors.geoWhite100,
        titleColorMobile: Colors.geoWhite100,
        placeholderColor: Colors.zelWhite31,
        fontSize: '',
        lineHeight: '',
        categoryText: Colors.geoWhite31,
        categoryWeight: '',
        categoryColorHover: '',
        authorText: 'rgba(255,255,255,0.47)',
        authorCuratorText: Colors.geoWhite100,
        authorTextMobile: Colors.geoWhite100,
        authorWeight: '400',
        authorTextSize: Colors.geoWhite73,
        authorColor: Colors.geoWhite47,
        authorColorHover: Colors.geoWhite100,
        authorColorHoverMobile: Colors.geoWhite61,
        authorArrowIconColor: Colors.geoWhite47,
        textAreaColor: Colors.geoWhite31,
        viewCardText: '#FEFEFE',
        viewCardStroke: '#909090',
        marginTop: '',
        marginBottom: '',
        designerLink: Colors.geoWhite100,
        moreProjects: '#FFFFFF',
        offsetTop: '',
        madeBy: Colors.geoWhite47,
        border: 'transparent',
        competitionMsg: Colors.geoWhite100
    },
    backgroundModal: {
        gradient: 'linear-gradient(180deg, rgba(38, 44, 48, 0.52) 0%, rgba(38, 44, 48, 0.9) 100%)'
    },
    footerView: {
        backgroundColor: '#22282c',
        textColor: Colors.geoWhite61,
        textHoverColor: Colors.generalPeaGreen,
        link: Colors.geoWhite47,
        linkHover: Colors.geoWhite100,
        linkArrow: Colors.geoWhite27
    },
    arrowWithText: {
        hover: {
            text: {
                color: 'rgb(254,254,254)'
            },
            svg: {
                fill: 'rgb(254,254,254)',
                stroke: 'rgb(254,254,254)'
            }
        },
        longreadSort: {
            text: {
                color: '#151514'
            },
            svg: {
                fill: '#151514',
                stroke: Colors.galBlack100
            }
        }
    },
    teamsPage: {
        dropdown: {
            text: {
                color: '#f4f4f4'
            }
        },
        text: {
            point: {
                color: '#f4f4f4'
            },
            label: {
                color: '#8E9193'
            },
            color: '#ffffff'
        }
    },
    fixedFooter: {
        background: {
            color: '#353A3E'
        },
        logo: {
            color: '#FEFEFE'
        },
        menuItems: {
            color: '#8E9193',
            colorHover: 'rgb(254, 254, 254)'
        },
        doc: {
            color: '#909090',
            colorHover: '#151514'
        },
        icons: {
            circle: '#353A3E'
        },
        dropdown: {
            color: '#8E9193',
            fill: '#8E9193'
        }
    },
    legals: {
        textColor: Colors.geoWhite100,
        background: "".concat(Colors.geo, "FA"),
        closeBtn: Colors.geoWhite47,
        link: Colors.geoWhite47,
        linkHover: Colors.geoWhite100
    },
    projectEdit: {
        imgContainerBg: '#353A3E',
        svgImgFill: Colors.zelWhite47,
        textTips: Colors.zelWhite47,
        locationText: Colors.geoWhite61,
        locationBoldText: Colors.geoWhite47,
        label: Colors.zelWhite47,
        radio: {
            dot: {
                color: '#151514'
            }
        },
        btns: {
            create: {
                bg: '',
                color: '',
                weight: '',
                border: ''
            }
        }
    },
    icon: {
        default: 'rgba(255,255,255,0.47)',
        hover: Colors.geoWhite100,
        active: Colors.geoWhite100,
        hoverSpecial: Colors.geoWhite100,
        hoverSpecialActive: Colors.geoWhite73,
        activeSpecial: Colors.geoWhite100,
        activeFillIconColor: Colors.geoWhite100,
        chat: {
            activeSpecial: '#151514',
            default: '#909090',
            activeFillIconColor: '#151514',
            hoverSpecialActive: '#151514'
        }
    },
    tags: {
        extraBackgroundColor: 'transparent',
        textColor: Colors.geoWhite100,
        tagsBgDisabled: '#272b2d ',
        tagsColorDisabled: Colors.geoWhite21,
        tagsBorderDisabled: '#3f4548',
        projectEditTagsPlusBtn: '#fefefe',
        tagsSearchPlaceholderText: Colors.geoWhite61,
        emptySearchColor: Colors.geoWhite61,
        borderColor: Colors.geoWhite47,
        borderColorHover: Colors.geoWhite100,
        borderColorActive: Colors.geoWhite100,
        removable: {
            textColorHover: Colors.geoWhite47,
            borderColorHover: Colors.geoWhite47,
            // Selected when removable
            selected: {
                line: {
                    color: Colors.galBlack100
                },
                textColor: Colors.galBlack47,
                borderColor: '#a4b54d'
            }
        },
        selected: {
            backgroundColor: '#a4b54d',
            borderColor: '#a4b54d',
            textColor: '#2a3034',
            hover: {
                borderColor: '#a4b54d'
            }
        },
        disabled: {
            backgroundColor: '#272b2d',
            borderColor: '#3f4548',
            color: Colors.geoWhite21,
            hover: {
                borderColor: '#3f4548'
            }
        },
        educational: {
            backgroundColor: Colors.geoWhite100,
            color: Colors.galBlack100,
            backgroundColorHover: Colors.galBlack31,
            projectEdit: {
                backgroundColor: Colors.galBlack100,
                color: '#fefefe',
            }
        },
        modal: {
            search: {
                color: Colors.geoWhite47,
                border: Colors.geoWhite21
            },
            text: {
                color: Colors.geoWhite47
            },
            active: {
                activeTag: Colors.geoWhite100,
                border: Colors.geoWhite61
            },
            notActive: {
                tag: Colors.geoWhite73,
                border: Colors.geoWhite31
            },
            simpleTag: {
                color: Colors.geoWhite100
            }
        }
    },
    skeleton: {
        skeletonBgColor: '',
        background: "linear-gradient(\n            90deg,\n            rgba(255, 255, 255, 0.02),\n            rgba(255, 255, 255, 0.02),\n            rgba(255, 255, 255, 0.02),\n            rgba(255, 255, 255, 0.07),\n            rgba(255, 255, 255, 0.02),\n            rgba(255, 255, 255, 0.02),\n            rgba(255, 255, 255, 0.02)\n        )"
    },
    selectContextModal: {
        background: Colors.geo,
        opacityTop: 'linear-gradient(to top, rgba(42, 48, 52, 0), rgba(42, 48, 52, 0.6) 12.39%, rgba(42, 47, 52, 1))',
        opacityBottom: 'linear-gradient(to bottom, rgba(42, 48, 52, 0), rgba(42, 48, 52, 0.6) 12.39%, rgba(42, 47, 52, 1))',
        variantTextColor: Colors.geoWhite100
    },
    shopIcon: Colors.geoWhite100,
    shareIcon: Colors.geoWhite100,
    navigationBar: {
        borderBottomColor: Colors.geoWhite21,
        textActiveColor: '#ffffff',
        boxShadow: 'inset 0px 2px 3px rgba(22, 22, 23, 0.21)',
        closeButtonColor: '#FFFFFF',
        backgroundColor: Colors.geo,
        backgroundScrollingColor: 'rgba(42, 48, 52, 0.71)',
        chat: {
            btns: {
                hollow: {
                    text: {
                        main: '#151514'
                    },
                    bg: {
                        main: 'transparent',
                        hover: 'transparent'
                    },
                    border: {
                        main: 'rgb(182, 182, 181)',
                        hover: 'rgb(182, 182, 181)'
                    }
                },
                filled: {
                    text: {
                        main: '#fefefe'
                    },
                    bg: {
                        main: '#151514',
                        hover: '#151514'
                    },
                    border: {
                        main: 'transparent',
                        hover: 'transparent'
                    }
                }
            }
        },
        font: {
            l: {
                fontSize: '17px',
                lineHeight: '22px'
            },
            m: {
                fontSize: '15px',
                lineHeight: '20px'
            },
            s: {
                fontSize: '13px',
                lineHeight: '16px'
            }
        },
        links: {
            color: Colors.geoWhite73,
            hoverColor: Colors.geoWhite100,
            activeColor: Colors.geoWhite100
        },
        linksHse: {
            color: Colors.geoWhite47,
            hoverColor: Colors.geoWhite100,
            activeColor: Colors.geoWhite100
        },
        logoName: Colors.geoWhite100,
        login: {
            loginButtonColor: Colors.geoWhite47,
            loginButtonHoverColor: Colors.geoWhite100,
            noAvatarBackgroundColor: '#30363A',
            noAvatarTextColor: '#707477'
        },
        search: {
            color: '#FEFEFE',
            line: '#FFFFFF',
            svg: '#FEFEFE',
            svgHover: Colors.geoWhite100,
            colorFlex: 'rgb(254, 254, 254, 0.71)'
        },
        modalMobileLinks: {
            default: Colors.galBlack47,
            active: '#C7D332'
        },
        linksWidgetLine: '#ffffff',
        linksWidgetLineGradient: Colors.geoWhite100,
        btns: {
            filled: {
                importantStyles: {
                    main: Colors.geoWhite100,
                    disabled: Colors.galBlack10,
                    hover: Colors.geoWhite100,
                    active: Colors.galBlack10,
                    text: Colors.galBlack100
                },
                background: {
                    main: Colors.generalPeaGreen,
                    disabled: Colors.galBlack10,
                    hover: 'rgba(164, 181, 77, 0.8)',
                    active: 'rgba(164, 181, 77, 0.8)'
                },
                text: {
                    main: Colors.galBlack100,
                    disabled: Colors.geoWhite73
                }
            },
            hollow: {
                background: {
                    disabled: Colors.geoWhite73
                },
                text: {
                    main: '#ffffff',
                    grey: Colors.geoWhite31,
                    black: Colors.galBlack100,
                    disabled: Colors.geoWhite47
                },
                border: {
                    main: Colors.geoWhite21,
                    hover: Colors.geoWhite31,
                    active: Colors.geoWhite47,
                    disabled: Colors.geoWhite10
                }
            },
            send: {
                color: '',
                textColor: '',
                border: ''
            },
            create: {
                bg: 'rgb(164, 181, 77)',
                color: Colors.galBlack100,
                weight: '',
                border: ''
            },
            changeLang: {
                background: Colors.geoWhite5,
                color: Colors.geoWhite47,
                colorMobile: Colors.geoWhite100,
                colorHover: Colors.geoWhite47,
                active: Colors.geoWhite100
            }
        },
        navBarCreate: {
            boldTextColor: Colors.geoWhite61,
            textColor: '#6C7073',
            logoFillColor: {
                first: '#FEFEFE',
                second: '#A4B54D'
            }
        },
        dropdownStyled: {
            bg: '#30363a',
            border: '1px solid rgba(254, 254, 254, 0)',
            borderFocused: 'rgba(254, 254, 254, 0.13)',
            textColor: '#fefefe',
            opacity: '0.31',
            fill: '#fefefe'
        },
        profile: {
            textColor: Colors.geoWhite100,
            textSmallColor: Colors.geoWhite61,
            bg: Colors.geo
        }
    },
    mobileSearch: {
        wrapper: {
            background: Colors.geoWhite5
        },
        input: {
            color: Colors.geoWhite100
        },
        item: {
            color: Colors.geoWhite100
        }
    },
    likesController: {
        textColor: Colors.geoWhite47,
        fill: '',
        hearthColor: Colors.geoWhite47,
        hearthColorLikes: Colors.redFailed,
        text: Colors.geoWhite47
    },
    viewCount: {
        text: Colors.geoWhite47
    },
    likesPopUp: {
        bg: '#1c1c1b',
        color: '#abaeaf',
        hoverColor: Colors.geoWhite100,
        bgHover: '',
        borderBox: '1px solid transparent'
    },
    researchPage: {
        colorMainTitle: Colors.geoWhite61
    },
    btns: {
        submit: {
            bg: '#fede31',
            color: Colors.galBlack100,
            border: '',
            hoverBg: '#efd649',
            weight: ''
        },
        cancel: {
            bg: '',
            color: '',
            border: '',
            hoverBorder: ''
        },
        hollow: {
            border: Colors.geoWhite21,
            borderActive: Colors.geoWhite100,
            icon: Colors.geoWhite100
        }
    },
    inputs: {
        optionsBox: {
            shadowColor: 'linear-gradient(180deg, rgba(50, 55, 59, 0.09) 0%, #32373b 100%)',
            borderColor: 'transparent'
        },
        dropdown: {
            backgroundColorHover: ''
        },
        backgroundColor: '#30363a',
        borderColor: '#30363a',
        borderFocusedColor: Colors.geoWhite31,
        color: '#f4f4f4',
        disabledColor: Colors.geoWhite100,
        pagination: {
            backgroundColor: Colors.galBlack10,
            color: Colors.galBlack100
        },
        box: {
            backgroundColor: Colors.geoWhite5
        },
        label: {
            color: '#f4f4f4'
        },
        text: {
            color: Colors.geoWhite47
        }
    },
    dropdown: {
        textColor: Colors.galBlack100,
        bgColor: '#32373b',
        bgColorHover: 'rgba(31, 31, 31, 0.31)',
        borderColor: '#30363a',
        borderFocusColor: 'transparent',
        arrow: '#fefefe'
    },
    spinner: {
        loaderColor: '#ffffff',
        loaderBg: Colors.geo
    },
    designerPage: {
        emptyProjectsLoader: {
            color: Colors.geoWhite100,
            bg: '#30363a'
        },
        likePowerIcon: {
            color: Colors.geoWhite47,
            bg: 'rgba(254,254,254,0.73)',
            opacity: '0.73',
            msgColor: Colors.galBlack100,
            shrinkColor: Colors.galBlack100,
            hover: Colors.geoWhite73
        },
        textColor: Colors.geoWhite100,
        textColor2: Colors.geoWhite47,
        textColor3: Colors.geoWhite100,
        fill: '#FEFEFE',
        moreDropdown: '',
        slideLine: '#f4f4f4',
        slideLineInActive: Colors.galBlack47,
        slideHover: Colors.geoWhite73,
        viewCardText: '#FEFEFE',
        viewCardStroke: '#8e9193'
    },
    teamsEdit: {
        inputs: {
            labelColor: '#575B5E',
            importantColor: Colors.geoWhite47,
            whiteLabelColor: Colors.galBlack47,
            bgDisabled: '',
            border: '',
            bg: '',
            color: '#f4f4f4',
            colorShadow: 'rgb(142, 145, 147)'
        }
    },
    designerEdit: {
        btns: {
            edit: {
                bg: 'rgb(164, 181, 77)',
                color: Colors.galBlack100,
                border: '',
                hoverBg: '#efd649',
                weight: ''
            },
            cancel: {
                bg: '',
                color: '#f4f4f4',
                border: '',
                hoverBorder: ''
            },
            roundAdd: {
                svgColor: Colors.geoWhite100,
                textColor: Colors.geoWhite47
            }
        },
        localSwitch: {
            borderColor: Colors.geoWhite100,
            textColor: Colors.geoWhite100,
            textColorInactive: Colors.geoWhite47,
            textColorHover: Colors.geoWhite73
        },
        inputs: {
            labelColor: '#575B5E',
            importantColor: Colors.geoWhite47,
            whiteLabelColor: Colors.galBlack47,
            bgDisabled: '',
            border: '',
            bg: '',
            color: '#f4f4f4',
            colorShadow: 'rgb(142, 145, 147)'
        },
        smallText: {
            color73: Colors.geoWhite73,
            color100: '#f4f4f4',
            color47: Colors.geoWhite47,
            colorE7: '#e7e7e7'
        },
        editTitle: {
            color: '#f4f4f4'
        },
        mainTitle: {
            color: '#f4f4f4'
        },
        pageLink: {
            color: Colors.geoWhite100,
            hoverColor: Colors.geoWhite100
        },
        aboutProfile: {
            bg: '#353a3e',
            bgWhite: Colors.geoWhite73,
            color: Colors.geoWhite100
        },
        account: {
            color: '#f4f4f4',
            color47: Colors.geoWhite47,
            goButtonColor: 'rgb(244,244,244)',
            color31: Colors.geoWhite31,
            fill: 'rgb(205, 205, 205)'
        },
        icons: {
            color: Colors.geoWhite47,
            colorHover: Colors.geoWhite100
        },
        disable: {
            color: Colors.geoWhite27,
            colorGeo: Colors.galBlack47
        },
        placeholder: {
            color: 'rgb(108, 112, 115)'
        }
    },
    map: {
        closeBtn: '#ffffff',
        bg: '#2a3034'
    },
    footer: {
        border: ''
    },
    errorModal: {
        textColor: Colors.geoWhite100,
        secondaryTextColor: Colors.geoWhite47,
        backgroundColor: Colors.geo
    },
    modal: {
        closeColor: Colors.geoWhite100,
        backgroundColor: 'linear-gradient(180deg, rgba(38, 44, 48, 0.52) 0%, rgba(38, 44, 48, 0.9) 100%)',
        solidBackgroundColor: Colors.geo
    },
    not_saved_modal: {
        title: '#f4f4f4',
        description: 'rgb(197, 198, 199)',
        cancel: Colors.galBlack100,
        proceed: Colors.geoWhite100
    },
    gallllery: {
        cardSubtext: '#919191',
        mainText: Colors.galBlack100,
        mainTextInactive: '#969696',
        hoverTitleText: '#FFD700',
        hoverText: '#919191',
        hoverAuthor: Colors.galBlack100,
        backgroundColor: 'white',
        borderBottomColor: 'transparent',
        boxShadow: 'none',
        backdrop: 'blur(1px)'
    },
    artz: {
        searchLine: {
            placeholderColor: '#1F1F1F',
            textColor: Colors.galBlack100
        },
        buttons: {
            viewAllColor: Colors.gal
        }
    },
    menuOverlay: {
        buttonBackground: '#353a3e',
        buttonContent: '#C5C6C7',
        buttonOpacity: 0.39,
        backgroundColor: '#2a3034',
        textColor: '#ffffff',
        textColorAlternative: '#ABAEAF',
        borderTitle: '#fefefe',
        flexBox: 'rgb(254, 254, 254, 0.71)'
    },
    approvals: {},
    isDarkText: false,
    link: {
        default: Colors.geoWhite47,
        hover: Colors.geoWhite100
    },
    scrollUp: {
        link: Colors.zelWhite100,
        background: 'transparent'
    },
    text: {
        label: Colors.geoWhite47
    }
};
//# sourceMappingURL=greyTheme.js.map